var _ellipse, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocustore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 13,
    rx: 12.5,
    ry: 13,
    fill: "#E5F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4654 20.658C10.3643 20.0272 11.1812 17.1976 11.6023 15.9274L14.2557 17.8984L11.3496 20.9208C11.097 21.096 10.5664 21.2887 10.4654 20.658Z",
    fill: "#65AFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.3205 4.88916C28.4827 -6.78322 9.26558 14.5767 9.2019 14.613C9.70204 17.8033 9.50627 16.4799 9.70204 17.8033C9.86845 18.9283 10.0837 20.2318 10.0837 20.2318C10.1915 20.6538 10.2774 20.8694 10.5752 20.9979C10.8729 21.1263 11.2158 21.0555 11.4438 20.8185L13.0509 19.1471C16.2775 15.7957 14.1361 17.9609 14.1295 17.8985C15.6569 15.6364 14.1804 17.4067 14.1295 17.3728L20.3205 4.88916Z",
    fill: "#228CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.42 1.72057C22.4564 1.56243 22.4006 1.39676 22.2771 1.29695C22.1537 1.19714 21.9855 1.18165 21.8471 1.25735L5.52669 10.1562C5.1592 10.3579 4.92286 10.748 4.90643 11.1798C4.89001 11.6116 5.096 12.0198 5.44701 12.2511L9.08033 14.6392C9.15539 14.6892 9.25329 14.6807 9.31936 14.6185L18.6778 5.15214C18.9305 4.88933 22.0576 1.54223 22.1334 1.61692C22.2092 1.69162 19.3757 5.59373 19.3096 5.67776L11.5527 15.9949C11.5168 16.0414 11.502 16.1019 11.5121 16.1606C11.5217 16.2187 11.5544 16.2699 11.6021 16.3015L16.727 19.6708C17.0434 19.8786 17.4368 19.9145 17.7831 19.7673C18.1295 19.6201 18.3861 19.3079 18.472 18.9292L22.42 1.72057Z",
    fill: "url(#paint0_linear_330_425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_330_425",
    x1: 14.6941,
    y1: 6.80879,
    x2: 31.945,
    y2: 12.1168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocustore);
export default __webpack_public_path__ + "static/media/docustore.b71fe834adfacd7b7abdefebfc24a2a9.svg";
export { ForwardRef as ReactComponent };